import React from 'react'

export default function Loading() {
  return <div>Logging you in...</div>
}



// WEBPACK FOOTER //
// ./src/Component/Loading.js